import React, { useEffect, useState } from "react";
import { Table, Button, Form, InputGroup } from "react-bootstrap";
import { useFormik } from "formik";
import { FaPlus, FaSave, FaTrash, FaTimes } from "react-icons/fa";

import { initialValues, validationSchema } from "./addonsValidation";
import {
  handleAddons_Create,
  handleAddons_Delete,
  handleAddons_Update,
  handleGetAddons_list,
  handleInputChange,
} from "./addonsModel";

const AddonsPage = () => {
  const [addons, setAddons] = useState([]);
  const [filter, setFilter] = useState({ page: 1, limit: 100 });
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [loaderADES, setLoaderADES] = useState(null);

  useEffect(() => {
    handleGetAddons_list({ filter, setAddons, setLoading });
  }, [filter]);

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      handleAddons_Create({
        setLoaderADES,
        addons,
        setAddons,
        values,
        resetForm,
      });
    },
  });

  const filteredAddons = addons.filter(
    (item) =>
      item.addon_name.toLowerCase().includes(search.toLowerCase()) ||
      item.addons_price.toString().includes(search)
  );

  return (
    <div className="p-3" style={{ fontSize: "0.85rem" }}>
      {/* Header & Search */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="mb-0">Addons</h6>
        <InputGroup style={{ width: "250px" }} size="sm">
          <Form.Control
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          {search && (
            <Button
              variant="outline-secondary"
              onClick={() => setSearch("")}
              style={{ padding: "0 8px" }}
            >
              <FaTimes />
            </Button>
          )}
        </InputGroup>
      </div>

      {/* Scrollable Table */}
      <div
        style={{
          maxHeight: "400px",
          overflowY: "auto",
          border: "1px solid #dee2e6",
          borderRadius: "4px",
        }}
      >
        <Table
          striped
          bordered
          hover
          size="sm"
          responsive
          style={{ marginBottom: 0 }}
        >
          <thead
            style={{
              position: "sticky",
              top: 0,
              backgroundColor: "white",
              zIndex: 2,
            }}
          >
            <tr>
              <th>Addons Name</th>
              <th>Price</th>
              <th style={{ width: "120px" }}>Actions</th>
            </tr>

            {/* Add New Addon Row */}
            <tr>
              <td>
                <Form.Control
                  style={{
                    height: "28px",
                    fontSize: "0.85rem",
                    padding: "2px 8px",
                  }}
                  name="addon_name"
                  value={formik.values.addon_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  isInvalid={
                    formik.touched.addon_name && formik.errors.addon_name
                  }
                  placeholder="Addons Name"
                />
                <Form.Control.Feedback
                  type="invalid"
                  style={{ fontSize: "0.75rem" }}
                >
                  {formik.errors.addon_name}
                </Form.Control.Feedback>
              </td>
              <td>
                <Form.Control
                  style={{
                    height: "28px",
                    fontSize: "0.85rem",
                    padding: "2px 8px",
                  }}
                  name="addons_price"
                  value={formik.values.addons_price}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  isInvalid={
                    formik.touched.addons_price && formik.errors.addons_price
                  }
                  placeholder="Price"
                  type="number"
                  min="0"
                />
                <Form.Control.Feedback
                  type="invalid"
                  style={{ fontSize: "0.75rem" }}
                >
                  {formik.errors.addons_price}
                </Form.Control.Feedback>
              </td>
              <td className="text-center" style={{ verticalAlign: "middle" }}>
                <Button
                  variant="primary"
                  size="sm"
                  onClick={formik.handleSubmit}
                  style={{ padding: "4px 8px", fontSize: "0.85rem" }}
                >
                  {loaderADES?.create === true ? (
                    <span
                      className="spinner-border spinner-border-sm me-1"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    <FaPlus />
                  )}
                </Button>
              </td>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={3} className="text-center py-2">
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Loading...
                </td>
              </tr>
            ) : filteredAddons.length > 0 ? (
              filteredAddons.map((addon) => (
                <tr key={addon.id}>
                  <td>
                    <Form.Control
                      style={{
                        height: "28px",
                        fontSize: "0.85rem",
                        padding: "2px 8px",
                      }}
                      value={addon.addon_name}
                      onChange={(e) =>
                        handleInputChange(
                          addon.id,
                          "addon_name",
                          e.target.value,
                          setAddons
                        )
                      }
                    />
                  </td>
                  <td>
                    <Form.Control
                      style={{
                        height: "28px",
                        fontSize: "0.85rem",
                        padding: "2px 8px",
                      }}
                      type="number"
                      step="0.01"
                      value={addon.addons_price}
                      onChange={(e) =>
                        handleInputChange(
                          addon.id,
                          "addons_price",
                          e.target.value,
                          setAddons
                        )
                      }
                      min="0"
                    />
                  </td>
                  <td className="d-flex justify-content-between">
                    <Button
                      variant="success"
                      size="sm"
                      onClick={() =>
                        handleAddons_Update({ setLoaderADES, item: addon })
                      }
                      disabled={loaderADES?.update === addon.id}
                    >
                      {loaderADES?.update === addon.id ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-1"
                            role="status"
                            aria-hidden="true"
                          ></span>                          
                        </>
                      ) : (
                        <FaSave />
                      )}
                    </Button>

                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() =>
                        handleAddons_Delete({
                          id: addon.id,
                          setLoaderADES,
                          setAddons,
                        })
                      }
                      disabled={loaderADES?.delete === addon.id}
                    >
                      {loaderADES?.delete === addon.id ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-1"
                            role="status"
                            aria-hidden="true"
                          ></span>                          
                        </>
                      ) : (
                        <FaTrash />
                      )}
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3} className="text-center text-muted py-2">
                  No Addons found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default AddonsPage;
